import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, numberFormat} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var renameKeys = function (obj) {
        /*Recursively renames "key" keys to "name" and
        renames "values" keys to "children" */
        obj.name = obj.key;
        delete obj.key;
        if (obj.values) {
            obj.children = obj.values;
            delete obj.values;
            obj.children.forEach(renameKeys);
        }
        return obj;
    };
    axios.post(url, filterParam).then(res => {
        let data = res.data;

        var nest = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            }).sortKeys(d3.ascending)
            .key(function (d) {
                return d.dim2_name;
            }).sortKeys(d3.ascending)
            .rollup(function (v) {
                return d3.sum(v, function (d) {
                    return d.metric1;
                })
            })
            .entries(data);

        /*The visualization requires there to be a root node*/
        var flareData = {key: chart.y1AxisDisplayName, values: []};
        flareData.values = nest;
        renameKeys(flareData);

        (function visualize() {
            var margin = 20, diameter = chart.width

            var svg = d3.select(divId).select("svg").remove();
            svg = d3.select(divId)
                .append("svg")
                .attr("width", chart.width)
                .attr("height", chart.height)
                .call(responsivefy)
                .append("g")
                .attr("transform", "translate(" + diameter / 2 + "," + diameter / 2 + ")");

            var g = svg.append("g")
            var metric1ColorScale = d3.scaleLinear()
                .domain([-1, 5])
                .range(["hsl(152,80%,80%)", "hsl(228,30%,40%)"])
                .interpolate(d3.interpolateHcl);

            var metric2ColorScale = d3.scaleOrdinal(fw_progressive_1way)

            var pack = d3.pack()
                .size([diameter - margin, diameter - margin])
                .padding(2);

            var root = d3.hierarchy(flareData)
                .sum(function (d) {
                    return d.value;
                })
                .sort(function (a, b) {
                    return b.value - a.value;
                });

            var focus = root,
                nodes = pack(root).descendants(),
                view;

            /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            var y1tip = tooltip_class()

            y1tip.attr('class', 'd3-tip'+divId.id)
                .html((d) =>{ return d.data.name+ colonAnnotation +numberFormat(d.value) })

            g.call(y1tip)*/

            d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            var div = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')

            var circle = g.selectAll("circle")
                .data(nodes)
                .enter()
                .append("circle")
                .attr("class", function (d) {
                    return d.parent ? d.children ? "nodes" : "node node--leafcircle" : "node node--root";
                })
                .style("fill", function (d) {
                    return d.children ? metric1ColorScale(d.depth) : // Add the colours dynamically
                        d.data.name.startsWith('1_C') ? "#00FF00" : d.data.name.startsWith('2_P') ? '#90EE90' : d.data.name.startsWith('3_L') ? "#FFFF00" : d.data.name.startsWith('4_I') ? "#FF0000" : metric2ColorScale(d.data.name)
                })
                .on("click", function (d) {
                    if (focus !== d) zoom(d), d3.event.stopPropagation();
                })
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(d.data.name + colonAnnotation + numberFormat(d.value))
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                });
            //.on("mouseover", y1tip.show)
            //.on("mouseout", y1tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            g.selectAll("text")
                .data(nodes)
                .enter()
                .append("text")
                .attr("class", "labels")
                //.style("fill-opacity", (d) =>{ return d.parent === root ? 1: 0 })
                .style("display", (d) => {
                    return d.parent === root ? "inline" : "none"
                })
                .text((d) => {
                    return d.data.name
                });

            var node = g.selectAll("circle,text");

            svg.style("background", metric1ColorScale(-1))
                .on("click", function () {
                    zoom(root);
                })

            zoomTo([root.x, root.y, root.r * 2 + margin]);

            function zoom(d) {
                focus = d;

                var transition = d3.transition()
                    .duration(d3.event.altKey ? 7500 : 750)
                    .tween("zoom", function () {
                        var i = d3.interpolateZoom(view, [focus.x, focus.y, focus.r * 2 + margin]);
                        return function (t) {
                            zoomTo(i(t));
                        };
                    });

                transition.selectAll("text")
                    .filter(function (d) {
                        return d.parent === focus || this.style.display === "inline";
                    })
                    .style("fill-opacity", function (d) {
                        return d.parent === focus ? 1 : 0;
                    })
                    .on("start", function (d) {
                        if (d.parent === focus) this.style.display = "inline";
                    })
                    .on("end", function (d) {
                        if (d.parent !== focus) this.style.display = "none";
                    });
            }

            function zoomTo(v) {
                var k = diameter / v[2];
                view = v;
                node.attr("transform", function (d) {
                    return "translate(" + (d.x - v[0]) * k + "," + (d.y - v[1]) * k + ")";
                });
                circle.attr("r", function (d) {
                    return d.r * k;
                });
            }

            function responsivefy(svg) {
                // get container + svg aspect ratio
                var container = d3.select(svg.node().parentNode),
                    width = parseInt(svg.style("width")),
                    height = parseInt(svg.style("height")),
                    aspect = width / height;

                // add viewBox and preserveAspectRatio properties,
                // and call resize so that svg resizes on inital page load
                svg.attr("viewBox", "0 0 " + width + " " + height)
                    .attr("perserveAspectRatio", "xMinYMid")
                    .call(resize);

                // to register multiple listeners for same event type,
                // you need to add namespace, i.e., 'click.foo'
                // necessary if you call invoke this function for multiple svgs
                d3.select(window).on("resize." + container.attr("id"), resize);

                // get width of container and resize svg to fit it
                function resize() {
                    var targetWidth = parseInt(container.style("width"));
                    svg.attr("width", targetWidth / 1.2);
                    svg.attr("height", Math.round(targetWidth / aspect));
                }
            }

            var sumstat = d3.nest()
                .key(d => {
                    return d.dim2_name
                }).sortKeys(d3.ascending).entries(data)

            var y1legend = svg.append('g')
                .selectAll('g')
                .data(sumstat)
                .enter()
                .append('g')
                .attr('display', function () {
                    return sumstat.length > 10 ? 'none' : 'block';
                    // return d.length > 10
                })
                .attr('class', 'legend')
                .attr('transform', (d, i) => 'translate(0,' + i * 25 + ')')


            y1legend.append('circle')
                .attr('cx', chart.width / 2 - 230)
                .attr('cy', -900)
                .attr('r', 10)
                .attr('dy', '0.75em')
                .attr('fill', d => {
                    return d.key.startsWith('1_C') ? "#00FF00" : d.key.startsWith('2_P') ? '#90EE90' : d.key.startsWith('3_L') ? "#FFFF00" : d.key.startsWith('4_I') ? "#FF0000" : metric2ColorScale(d.key)
                })

            y1legend.append('text')
                .data(sumstat, d => {
                    return d.key
                })
                .attr('x', chart.width / 2 - 200)
                .attr('y', -912)
                .attr('dy', '0.75em')
                .text(d => {
                    return d.key
                })
                .style('font-size', '20px')

        })(flareData);


    })
}
